import React from 'react';
import Components from 'mpm-components';
import Services from 'mpm-services';
import { Form, Button, Icon, Divider, Input, Grid, FormTextArea } from 'semantic-ui-react';
import Utilities from 'mpm-config/Utilities';
import MPMContext from 'mpm-config/context/MPMContext';
import { SourceCC } from 'mpm-classes/CessionCapture';
import { toClass } from 'class-converter';
import NumberFormat from 'react-number-format';

export default ({ cessionCapture, onChangeListSources, setMessage, editMode, onComplet }) => {
  const [categoriePeche, setCategoriePeche] = React.useState(cessionCapture.categoriePeche);
  const [checkedSourceCCList, setCheckedSourceCCList] = React.useState([]);
  const [loadingSource, setLoadingSource] = React.useState(false);
  const [savingSourceCC, setSavingSourceCC] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [modalData, setModalData] = React.useState({ open: false });
  const [source, setSource] = React.useState(new SourceCC());
  const [sourceIndex, setSourceIndex] = React.useState(cessionCapture.childrenSourceCC ? cessionCapture.childrenSourceCC.length : 0);
  const [sourceError, setSourceError] = React.useState(false);

  const onChangeSource = (name, value) => {
    let _source = source;
    _source = {
      ...source,
      [name]: value,
    };
    setSourceError(false);
    let found = false;
    cessionCapture.childrenSourceCC.forEach((elem) => {
      if (elem.typeSource === _source.typeSource && elem.codeSource === _source.codeSource) {
        found = true;
      }
    });
    if (found) {
      setSourceError(true);
    }
    setSource(_source);
  };

  const onAddSource = () => {
    setIsEdit(false);
    setSource(new SourceCC());
    setSourceIndex(cessionCapture.childrenSourceCC ? cessionCapture.childrenSourceCC.length : 0);
  };

  const onLoadSource = () => {
    if (Utilities.isNotNull(cessionCapture.dateCession) && Utilities.isNotNull(source.typeSource) && Utilities.isNotNull(source.codeSource)) {
      setLoadingSource(true);
      setMessage(null);

      Services.CessionsCaptureDataService.loadCessionCaptureSourceCC({
        dateCession: cessionCapture.dateCession,
        typeSource: source.typeSource,
        codeSource: source.codeSource,
        categoriePeche,
      })
        .then((result) => {
          setLoadingSource(false);
          if (!result.success) {
            setMessage({
              error: true,
              header: 'Chargement de source',
              content: result.message,
            });
            setSource(new SourceCC());
            return;
          }
          setCategoriePeche(result.categoriePeche);
          let _result = {
            ...result,
            allChildrenSrcEsp: result.childrenSrcEsp,
            childrenSrcEsp: [],
          };
          _result.allChildrenSrcEsp.map((espece) => {
            espece.id = null;
            return espece;
          });
          constructDelaisNineDays([_result]);
          setSource(new SourceCC());
          setTimeout(() => {
            setSource(toClass(_result, SourceCC));
          }, 100);
          if (isEdit) {
            updateStore(toClass(_result, SourceCC));
          }
        })
        .catch((error) => {
          setMessage({
            error: true,
            header: 'Chargement de source',
            content: `Une erreur est survenue lors de chargement de la source ${source.codeSource}`,
          });
          setLoadingSource(false);
        });
    }
  };
  const constructDelaisNineDays = (rows = []) => {
    let messages = [];

    rows.forEach((elem) => {
      if (Utilities.isNotNull(elem.message)) {
        messages.push(elem.message);
      }
    });
    if (messages.length > 0) {
      setMessage({
        error: true,
        header: 'Attention !!',
        content: messages,
        isArrray: true,
      });
    }
  };
  const onSelectEspeces = (selectedEspeces) => {
    let _source = {
      ...source,
      childrenSrcEsp: [...selectedEspeces],
    };
    let allChild = [];
    _source.allChildrenSrcEsp.forEach((elem) => {
      let _in = selectedEspeces.indexOf(elem);
      if (_in !== -1) {
        elem = selectedEspeces[_in];
      }
      elem.quantite = Number(elem.quantite);
      elem.disponible = Number(elem.disponible);
      allChild.push(elem);
    });
    _source = {
      ..._source,
      allChildrenSrcEsp: [...allChild],
    };
    setSource(_source);
  };

  const onChangeEspeceQuantite = (espece, value) => {
    let _source = { ...source };
    let index = _source.allChildrenSrcEsp.indexOf(espece);
    let nextValue = value;
    if (nextValue < 0) {
      espece.quantite = 0;
    } else {
      espece.quantite = nextValue;
    }
    _source.allChildrenSrcEsp[index] = espece;
    _source.childrenSrcEsp = _source.allChildrenSrcEsp.filter((item) => item.selected);
    setSource({
      ..._source,
    });
  };

  const updateStore = (_source) => {
    let _newCessionCapture = { ...cessionCapture };
    if (_newCessionCapture.childrenSourceCC[sourceIndex] !== undefined) {
      _newCessionCapture.childrenSourceCC[sourceIndex] = _source;
    } else {
      _newCessionCapture.childrenSourceCC.push(_source);
    }
    if (!_newCessionCapture.categoriePeche) {
      _newCessionCapture.categoriePeche = _source.categoriePeche;
    }

    onChangeListSources({ ..._newCessionCapture });
  };

  const fillCheckedSourceCCList = (sourceCC) => {
    if (sourceCC) {
      let tab = [...checkedSourceCCList];
      if (sourceCC.id_refDeclarationPeche && tab.indexOf(sourceCC.id_refDeclarationPeche) === -1) {
        tab.push(sourceCC.id_refDeclarationPeche);
      }
      if (sourceCC.id_refCessionCap && tab.indexOf(sourceCC.id_refCessionCap) === -1) {
        tab.push(sourceCC.id_refCessionCap);
      }
      if (sourceCC.id_refEtatAchat && tab.indexOf(sourceCC.id_refEtatAchat) === -1) {
        tab.push(sourceCC.id_refEtatAchat);
      }
      if (sourceCC.id_refCessionCapSrc && tab.indexOf(sourceCC.id_refCessionCapSrc) === -1) {
        tab.push(sourceCC.id_refCessionCapSrc);
      }
      setCheckedSourceCCList(tab);
      return tab;
    }
    return [];
  };
  const getSourceCCList = (sourceCC) => {
    if (sourceCC) {
      let tab = [];
      if (sourceCC.id_refDeclarationPeche && tab.indexOf(sourceCC.id_refDeclarationPeche) === -1) {
        tab.push(sourceCC.id_refDeclarationPeche);
      }
      if (sourceCC.id_refCessionCap && tab.indexOf(sourceCC.id_refCessionCap) === -1) {
        tab.push(sourceCC.id_refCessionCap);
      }
      if (sourceCC.id_refEtatAchat && tab.indexOf(sourceCC.id_refEtatAchat) === -1) {
        tab.push(sourceCC.id_refEtatAchat);
      }
      if (sourceCC.id_refCessionCapSrc && tab.indexOf(sourceCC.id_refCessionCapSrc) === -1) {
        tab.push(sourceCC.id_refCessionCapSrc);
      }
      return tab;
    }
    return [];
  };

  const onSaveSourceCC = () => {
    setMessage(null);
    let _source = { ...source };
    if (isEdit) {
      _source.sourceCCList = [];
    } else {
      _source.sourceCCList = checkedSourceCCList;
    }
    setSavingSourceCC(true);
    Services.CessionsCaptureDataService.saveSourceCC({ ..._source })
      .then((result) => {
        if (result.success) {
          _source = {
            ..._source,
            sourceCCList: fillCheckedSourceCCList(_source),
          };
          updateStore(_source);
          onAddSource();
        } else {
          setMessage({
            warning: true,
            header: 'Enregistrement source',
            content: result.message,
          });
        }
        setSavingSourceCC(false);
      })
      .catch((error) => {
        setMessage({
          error: true,
          header: 'Enregistrement source',
          content: "Une erreur est survenue lors d'enregistrement de la source",
        });
        setSavingSourceCC(false);
      });
  };

  const onEditSource = (_source) => {
    setIsEdit(true);
    setSource(new SourceCC());
    setTimeout(() => {
      setSourceIndex(cessionCapture.childrenSourceCC.indexOf(_source));
      setSource(_source);
    }, 50);
  };
  const onDeleteSource = (_source) => {
    let cc = cessionCapture;
    let index = cc.childrenSourceCC.indexOf(_source);

    setModalData({ ...modalData, loadingConfirm: true });
    if (cc.etat === '0') {
      let totalIds =
        cc.childrenSourceCC &&
        cc.childrenSourceCC
          .map((elem) => elem.id)
          .flat()
          .filter((elem) => elem);
      if (editMode && totalIds && _source.id && totalIds.length === 1) {
        Services.CessionsCaptureDataService.delete({ id: cc.id, etat: cc.etat })
          .then((result) => {
            setModalData({ open: false });
            if (result.data.success) {
              setMessage({
                success: true,
                header: 'Suppression cession de capture',
                content: 'Cession de capture a été supprimer avec succée.',
              });
              onComplet(true);
            } else {
              setMessage({
                error: true,
                header: 'Suppression de la source',
                content: result.data.message,
              });
            }
          })
          .catch((error) =>
            setMessage({
              error: true,
              header: 'Suppression de la source',
              content: 'Erreur lors de suppression de la source',
            })
          );
        return;
      } else {
        if (_source.id) {
          Services.CessionsCaptureDataService.deleteSourceCC(_source.id)
            .then((result) => {
              if (result.success) {
                afterDeleteSuccess(cc, _source, index);
              } else {
                setModalData({ open: false });
                setMessage({
                  error: true,
                  header: 'Suppression de la source',
                  content: result.message,
                });
              }
            })
            .catch((error) => {
              setModalData({ open: false });
              setMessage({
                error: true,
                header: 'Suppression de la source',
                content: 'Erreur lors de suppression de la source',
              });
            });
        } else {
          afterDeleteSuccess(cc, _source, index);
        }
      }
    } else {
      afterDeleteSuccess(cc, _source, index);
    }
    setIsEdit(false);
    setSource(new SourceCC());
    setSourceIndex(cessionCapture.childrenSourceCC.length);
  };
  const afterDeleteSuccess = (cc, source, index) => {
    let newChecked = [...checkedSourceCCList];
    let _sourceCCList = getSourceCCList(source);
    cc.childrenSourceCC.map((elem) => {
      _sourceCCList.forEach((ss) => {
        elem.sourceCCList.splice(elem.sourceCCList.indexOf(ss), 1);
        newChecked.splice(newChecked.indexOf(ss), 1);
      });
      return elem;
    });
    setCheckedSourceCCList(newChecked);
    cc.childrenSourceCC.splice(index, 1);
    if (!(cc.childrenSourceCC && cc.childrenSourceCC.length > 0)) {
      setCategoriePeche(undefined);
    }
    onChangeListSources({ ...cc });
    setModalData({ open: false });
  };

  const getDeleteContent = (cession, clickedSource) => {
    let deleteCession = false;
    if (editMode) {
      deleteCession =
        clickedSource.id &&
        cession.childrenSourceCC
          .map((elem) => elem.id)
          .flat()
          .filter((elem) => elem).length === 1;
    } else {
      deleteCession = clickedSource.id && cession.childrenSourceCC.length === 1;
    }
    if (deleteCession) {
      return 'Êtes vous sur de bien vouloir supprimer cette source ? Attention la cession capture va être supprimer !!';
    } else {
      return 'Êtes vous sur de bien vouloir supprimer cette source ? ';
    }
  };

  return (
    <MPMContext.Consumer>
      {(context) => (
        <>
          <Grid columns="equal">
            <Grid.Column computer={5} mobile={16}>
              {' '}
            </Grid.Column>
            <Grid.Column>
              <Components.Regions.RegionWithoutHeader>
                <Form size="small">
                  <Form.Group widths="equal">
                    <Form.Dropdown label="Type Source" selection value={source.typeSource} options={Utilities.getTypeSourceDropDown(Utilities.getTypeSourceValueByRole(context.connectedUser.role))} onChange={(event, { value }) => onChangeSource('typeSource', value)} />
                    <Form.Input
                      label="Code Source"
                      name="codeSource"
                      size="small"
                      disabled={isEdit}
                      error={sourceError}
                      value={source.codeSource}
                      onChange={({ target }) => onChangeSource('codeSource', target.value)}
                      action={
                        <Button disabled={sourceError} loading={loadingSource} onClick={() => onLoadSource()} positive>
                          Charger
                        </Button>
                      }
                    />
                  </Form.Group>
                </Form>
              </Components.Regions.RegionWithoutHeader>
            </Grid.Column>
          </Grid>
          <Grid columns="equal">
            <Grid.Column computer={5} mobile={16}>
              <Components.Regions.RegionWithHeader title="label.sources" headerColor="blue" headerSize="small">
                <Components.Tables.SmartTable
                  header={[
                    {
                      selector: 'codeSource',
                      collapsing: false,
                      label: 'Source',
                      positive: (row) => !row.id,
                      component: (row) => (
                        <>
                          {Utilities.getTypeSourceName(row.typeSource)} <br /> {row.codeSource}
                        </>
                      ),
                    },
                    {
                      selector: 'codeSource',
                      collapsing: true,
                      label: 'Actions',
                      positive: (row) => !row.id,
                      component: (row) => (
                        <Button.Group size="mini">
                          <Button onClick={() => onEditSource(row)} icon>
                            {editMode ? <Icon name="eye" /> : <Icon name="edit" />}
                          </Button>
                          <Button
                            icon
                            negative
                            onClick={() =>
                              setModalData({
                                data: row,
                                open: true,
                                title: 'Confirmation de supression',
                                content: getDeleteContent(cessionCapture, row),
                                loadingConfirm: false,
                              })
                            }
                          >
                            <Icon name="trash" />
                          </Button>
                        </Button.Group>
                      ),
                    },
                  ]}
                  data={cessionCapture.childrenSourceCC}
                  selectable={false}
                  grouped={false}
                  pagination={true}
                  rowsPerPage={5}
                  striped={true}
                  sortable={true}
                />
              </Components.Regions.RegionWithHeader>
            </Grid.Column>
            <Grid.Column>
              <Components.Regions.RegionWithHeader title="label.especes" headerColor="blue" headerSize="small">
                {source.allChildrenSrcEsp && source.allChildrenSrcEsp.length > 0 && (
                  <Components.Tables.SmartTable
                    header={[
                      {
                        selector: 'sourceDetail',
                        label: 'Source',
                        component: (row) => <FormTextArea value={row.sourceDetail} rows={2} />,
                      },
                      {
                        selector: 'refEspece.libelle',
                        label: 'Espece',
                      },
                      {
                        selector: 'disponible',
                        label: 'Disponible en (KG)',
                        component: (row) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.disponible} />,
                      },
                      {
                        selector: 'quantite',
                        label: 'Quantité cédée en (KG)',
                        component: (row) => <NumberFormat min={0} customInput={Input} thousandSeparator="" decimalScale={3} allowedDecimalSeparators={('.', ',')} error={!Utilities.isNumber(row.quantite) || row.quantite > row.disponible} value={row.quantite} onChange={({ target }) => onChangeEspeceQuantite(row, target.value)} />,
                      },
                    ]}
                    data={source.allChildrenSrcEsp}
                    selectable={true}
                    grouped={false}
                    pagination={true}
                    rowsPerPage={5}
                    striped={true}
                    sortable={true}
                    onSelectRows={(rows) => onSelectEspeces(rows)}
                  />
                )}

                {source.childrenSrcEsp && source.childrenSrcEsp.length > 0 && (
                  <>
                    <Divider />
                    <Components.Tables.SmartTable
                      header={[
                        {
                          selector: 'refEspece.libelle',
                          label: 'Espece',
                        },
                        {
                          selector: 'disponible',
                          label: 'Disponible en (KG)',
                          component: (row) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.disponible} />,
                        },
                        {
                          selector: 'quantite',
                          label: 'Quantité cédée en (KG)',
                          component: (row) => <NumberFormat min={0} displayType={'text'} thousandSeparator=" " decimalScale={3} allowedDecimalSeparators={('.', ',')} value={row.quantite} />,
                        },
                      ]}
                      data={source.childrenSrcEsp}
                      grouped={true}
                      groupeBy="refEspece.libelle"
                      groupeSums={['disponible', 'quantite']}
                      rowsPerPage={5}
                      pagination={true}
                      striped={true}
                      sortable={false}
                      selectable={false}
                    />
                    <Button floated="right" loading={savingSourceCC} disabled={source.childrenSrcEsp.length === 0} onClick={() => onSaveSourceCC()} icon primary size="mini">
                      <Icon name="plus" />
                    </Button>
                  </>
                )}
              </Components.Regions.RegionWithHeader>
            </Grid.Column>
          </Grid>
          {modalData && <Components.Modals.Confirmation modalData={modalData} onConfirm={(data) => onDeleteSource(data)} onCancel={() => setModalData({ open: false })} />}
        </>
      )}
    </MPMContext.Consumer>
  );
};
